// extracted by mini-css-extract-plugin
module.exports = {"title":"_4b805","description":"_02d55","wrapper":"_7d674","counter":"_50985"};